/**
 * Collection grid — subscribe prices + subscription quick-add (bundles + all subscribe SKUs).
 */
(function () {
  'use strict';

  var productFetchCache = Object.create(null);

  function getApi() {
    return window.RNC_BUNDLE_GIFTS;
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function hasAllocations(product) {
    var api = getApi();
    return api && api.productHasSubscribePlans(product);
  }

  function fetchProductByHandle(handle) {
    if (productFetchCache[handle]) {
      return productFetchCache[handle];
    }
    productFetchCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
    return productFetchCache[handle];
  }

  function getProductFromButton(btn) {
    var productId = btn.getAttribute('data-product-id') || '';
    if (!productId) return null;
    var jsonEl = document.getElementById('product-grid-' + productId);
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyPricesToCard(article, prices) {
    if (!article || !prices || prices.display == null) return;

    var styling = article.querySelector('[data-rnc-subscribe-price]');
    if (!styling) return;

    var currentEl = styling.querySelector('[data-rnc-price-current]');
    if (currentEl) currentEl.innerHTML = formatMoney(prices.display);

    var compareWrap = styling.querySelector('.compare-at-price');
    var compareEl = styling.querySelector('[data-rnc-price-compare]');

    if (prices.compare > prices.display) {
      if (!compareWrap) {
        compareWrap = document.createElement('span');
        compareWrap.className = 'compare-at-price';
        compareEl = document.createElement('span');
        compareEl.className = 'money';
        compareEl.setAttribute('data-rnc-price-compare', '');
        compareWrap.appendChild(compareEl);
        styling.appendChild(compareWrap);
      }
      if (compareEl) compareEl.innerHTML = formatMoney(prices.compare);
      compareWrap.style.display = '';
    } else if (compareWrap) {
      compareWrap.style.display = 'none';
    }
  }

  function promoDefaultOnetime() {
    var api = getApi();
    return !!(api && api.config && api.config.promoDefaultOnetime);
  }

  function syncSubscribeGridPrices(root) {
    if (promoDefaultOnetime()) return Promise.resolve();

    var api = getApi();
    if (!api) return Promise.resolve();

    root = root || document;
    var jsonEls = root.querySelectorAll ? root.querySelectorAll('.product-grid-json') : [];

    var tasks = Array.prototype.map.call(jsonEls, function (jsonEl) {
      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return Promise.resolve();
      }
      if (!product || !api.productHasSubscribePlans(product)) return Promise.resolve();

      var article = jsonEl.closest('.indiv-product');
      if (!article || !article.querySelector('[data-rnc-subscribe-price]')) return Promise.resolve();

      function applyFromProduct(p) {
        var prices = api.resolveSubscribeGridPrices(p);
        if (prices) applyPricesToCard(article, prices);
      }

      if (hasAllocations(product)) {
        applyFromProduct(product);
        return Promise.resolve();
      }

      return fetchProductByHandle(product.handle).then(function (fetched) {
        applyFromProduct(fetched || product);
      });
    });

    return Promise.all(tasks);
  }

  function initPriceSync() {
    syncSubscribeGridPrices(document);

    var container = document.getElementById('AjaxinateContainer');
    if (!container || container.dataset.rncPriceObserver) return;
    container.dataset.rncPriceObserver = '1';

    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncSubscribeGridPrices(container);
      }, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function runButtonAdd(btn, addPromise) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    return addPromise
      .then(function () {
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        console.error('RNC quick add failed', err);
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      });
  }

  function handleBundleQuickAtc(btn, api) {
    var handle = btn.getAttribute('data-bundle-handle') || '';
    var variantId = btn.getAttribute('data-variant-id') || '';
    if (!handle || !variantId) return;

    var product = getProductFromButton(btn);
    var cadence = (api.config.defaultCadence && api.config.defaultCadence[handle]) || '60';

    function runWithProduct(p) {
      var useOneTime = promoDefaultOnetime();
      var sellingPlanId = '';
      if (!useOneTime && p) {
        sellingPlanId = api.resolveSellingPlanId(p, cadence);
      }
      runButtonAdd(
        btn,
        api.addBundleToCart({
          variantId: variantId,
          sellingPlanId: sellingPlanId,
          bundleHandle: handle,
          isSubscribe: !useOneTime,
          openDrawer: true,
        })
      );
    }

    if (product && api.productHasSubscribePlans(product)) {
      runWithProduct(product);
      return;
    }

    fetchProductByHandle(handle).then(function (fetched) {
      runWithProduct(fetched || product);
    });
  }

  function handleSubscribeQuickAtc(btn, api) {
    var variantId = btn.getAttribute('data-variant-id') || '';
    if (!variantId) return;

    var product = getProductFromButton(btn);
    var useOneTime = promoDefaultOnetime();
    var sellingPlanId = useOneTime || !product ? '' : api.resolveFirstSellingPlanId(product);

    runButtonAdd(
      btn,
      api.addSubscribeLineToCart({
        variantId: variantId,
        sellingPlanId: sellingPlanId,
        openDrawer: true,
      })
    );
  }

  document.addEventListener('click', function (e) {
    var bundleBtn = e.target.closest('[data-rnc-bundle-quick-atc]');
    if (bundleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var api = getApi();
      if (api) handleBundleQuickAtc(bundleBtn, api);
      return;
    }

    var subBtn = e.target.closest('[data-rnc-subscribe-quick-atc]');
    if (subBtn) {
      e.preventDefault();
      e.stopPropagation();
      var apiSub = getApi();
      if (apiSub) handleSubscribeQuickAtc(subBtn, apiSub);
    }
  });

  function init() {
    initPriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.RNC_BUNDLE_COLLECTION = {
    syncSubscribeGridPrices: syncSubscribeGridPrices,
    syncBundleGridPrices: syncSubscribeGridPrices,
  };
})();
